import filterItemsBy from './filterItemsBy'
import filterByNodes from './filterByNodes'
import forOwn from 'mout/object/forOwn'
import sortByPropText from './sortByPropText'

/**
 * Filter and sort items
 * @param {object} filters Active filters 
 * @param {object} items All items
 * @param {object} nodes All nodes
 * @param {object} activeItems Items that are inside active set content in format {[id]: true}
 * @returns {array} Filtered and sorted items 
 */
export default function filterAndSortItems(filters, items, nodes, activeItems) {
  const filterTranslate = {
    'Name': 'name',
    'ContentType': 'contentType',
    'ItemType': 'itemType',
    'QuestionText': 'question',
    'Code': 'code',
    'Node': 'node',
  }

  let filteredItems = Object.assign({}, items)

  forOwn(filters, (val, key, o) => {
    if (val && key !== 'Node') {
      filteredItems = filterItemsBy(filteredItems, filterTranslate[key], val, activeItems)
    } else if (val && key === 'Node') {
      filteredItems = filterByNodes(nodes, filteredItems, val, activeItems)
    }
  })

  let sortedFilteredItems = []
  
  forOwn(filteredItems, (val, key, o) => {
    if (!val.deleted) {
      sortedFilteredItems.push(val)
    }
  })

  sortedFilteredItems = sortByPropText(sortedFilteredItems, 'name')

  return sortedFilteredItems

}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/filterAndSortItems.js